const initialState = {
    result: [],
    listResult: [],
    text: '',
    loaderSearch: false,
};
const search = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_LIST_RESULT_SEARCH':
            return {...state, result: action.result};
        case 'CHANGE_LIST_PAGE_RESULT_SEARCH':
            return {...state, listResult: action.listResult};
        case 'CHANGE_TEXT_INPUTS_SEARCH':
            return {...state, text: action.text};
        case 'CHANGE_LOADER_INPUT_SEARCH':
            return {...state, loaderSearch: action.loaderSearch};
        default:
            return state;
    }
};

export default search;